import React, { useEffect, useState } from "react";
import rest from "../../rest";
import MUIDataTable from "mui-datatables";
import textLabels from "../dataTable/textLabel";

const OngletHistorique = ({ idBenevole }) => {
  const [donneHisto, setDonneHisto] = useState([]);

  useEffect(() => {
    var paramsData = {
      vId: idBenevole,
    };
    rest.post("/benevols/historique.json", paramsData).then((response) => {
      // Trier les manifestations par la première tranche de la première activité
      const historique = response.data.Historique;
      historique.sort((a, b) => {
        const firstDateA = a.Activite?.[0]?.Tranches?.[0]?.Date 
            ? new Date(a.Activite[0].Tranches[0].Date)
            : null;
    
        const firstDateB = b.Activite?.[0]?.Tranches?.[0]?.Date 
            ? new Date(b.Activite[0].Tranches[0].Date)
            : null;
    
        // Si l'une des dates est nulle, on les place en conséquence
        if (firstDateA === null && firstDateB === null) return 0;
        if (firstDateA === null) return 1;
        if (firstDateB === null) return -1;

        return firstDateA - firstDateB;
    });
      setDonneHisto(historique);
    });
  }, [idBenevole]);

  const columns = [
    {
      label: "ID",
      name: "idManif",
      options: {
        viewColumns: false,
        filter: false,
        display: "excluded",
      },
    },
    {
      label: "Manif",
      name: "nomManif",
      options: {
        filter: true,
        sortThirdClickReset: true,
      },
    },
    {
      label: "Edition",
      name: "edition",
      options: {
        display: true,
        filter: true,
        sortThirdClickReset: true,
      },
    },
    {
      label: "Activité(s)",
      name: "Activite",
      options: {
        filter: true,
        sortThirdClickReset: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value
            .filter((item) => item.Tranches && item.Tranches.length > 0)
            .map((item) => item.nom)
            .join(",");
        },
      },
    },
    {
      label: "Date",
      name: "Activite",
      options: {
        filter: true,
        sortThirdClickReset: true,
        display: true,

        customBodyRender: (value, tableMeta, updateValue) => {
          const uniqueDates = [
            ...new Set(
              value.flatMap((item) =>
                item.Tranches.map((itemTran) => itemTran.Date)
              )
            ),
          ];
          return uniqueDates.join(", ");
        },

        setCellProps: () => ({
          style: {
            maxWidth: "200px",
          },
        }),
      },
    },
    {
      label: "Durée",
      name: "Activite",
      options: {
        filter: true,
        sortThirdClickReset: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const totalMinutes = value.reduce((total, item) => {
            const [hours, minutes] = item.duree.split(":").map(Number);
            const totalItemMinutes = hours * 60 + minutes;
            return total + totalItemMinutes;
          }, 0);

          const hours = Math.floor(totalMinutes / 60);
          const minutes = totalMinutes % 60;
          return `${hours.toString().padStart(2, "0")}:${minutes
            .toString()
            .padStart(2, "0")}`;
        },
      },
    },
  ];

  const options = {
    filter: false,
    print: false,
    download: false,
    viewColumns: false,
    selectableRows: "none",
    responsive: "vertical",
    textLabels: textLabels
  };

  return (
    <>
      <MUIDataTable data={donneHisto} columns={columns} options={options} />
    </>
  );
};

export default OngletHistorique;
